<div mat-dialog-content>
  <div class="grid">
    @if (customerGroups.length > 0;) {
      <div>
        <p class="list-inline-item font-weight-bold text-uppercase">Manage permissions for {{selectedGroup.name}}</p>
        <mat-form-field style="width: inherit;" style="float: right;">
          <mat-select matInput placeholder="Select other group" (selectionChange)="groupChanged($event)" name="name">
            <mat-select-trigger>{{selected}}</mat-select-trigger>
            @for (group of customerGroups; track group) {
              <mat-option [value]="group.id">
                <p><b>{{group.name}} </b></p>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <br>
          <hr>
            <mat-card appearance="outlined" class="col-6 card" style="float: left;">
              <mat-card-header>
                <div style="margin: auto;">
                  <mat-card-title>
                    <p class="list-inline-item font-weight-bold text-uppercase">Members</p>
                  </mat-card-title>
                  <mat-card-subtitle>
                    @for (member of members; track member; let i = $index) {
                      <ul>
                        {{member.userName}}
                        <br><hr>
                      </ul>
                    }
                  </mat-card-subtitle>
                </div>
              </mat-card-header>
            </mat-card>
            <mat-card appearance="outlined" class="col-6 card" style="float: left;">
              <mat-card-header>
                <div style="margin: auto;">
                  <mat-card-title>
                    <p class="list-inline-item font-weight-bold text-uppercase">Scouts</p>
                  </mat-card-title>
                  <mat-card-subtitle>
                    @for (scout of scouts; track scout; let i = $index) {
                      <ul>
                        {{scout.scoutCode}}
                        <br><hr>
                      </ul>
                    }
                  </mat-card-subtitle>
                </div>
              </mat-card-header>
            </mat-card>
            <div class="col-12">
              <mat-form-field style="width: inherit;">
                <mat-select matInput placeholder="Select other user" required name="name">
                  @for (user of users; track user) {
                    <mat-option [value]="user.name">
                      <p><b>{{user.name}} </b> ({{user.unit}})</p>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }
      </div>
      <br>
        <hr>
        </div>
        <div mat-dialog-actions>
          <div class="col-12">
            <button class="btn btn-secondary scanner" style="right: 0px; position: absolute;"
              mat-raised-button color="primary" (click)="okayClick()">
              <p class="text btn-text">
                OKAY
              </p>
            </button>
          </div>